import React, { memo } from 'react';
import SvgIcon from '@components/display/SvgIcon/SvgIcon';
import { upperFirst } from 'utils/utils';
import currency from '@filters/currency';
import { getUserLang } from '@utils/url/urlUtils';

const DishHeader = ({ dish }) => (
  <>
    <div className='dish-details-modal__title-row'>
      {dish.variables?.top && <SvgIcon type='top' />}
      <div className='dish-details-modal__name'>{upperFirst(dish.name)}</div>
    </div>

    <div className='dish-details-modal__info-wrapper'>
      <div className='dish-details-modal__price'>{currency(dish.price)}</div>
      {dish.weight && <div className='dish-details-modal__weight'>{dish.weight}</div>}
    </div>

    <div className='dish-details-modal__tags'>
      {dish.variables?.hot && (
        <div className='dish-details-modal__tag'>
          <SvgIcon type='hot' />
        </div>
      )}
      {dish.variables?.vegetarian && (
        <div className='dish-details-modal__tag'>
          <SvgIcon type='vegetarian' />
        </div>
      )}
    </div>

    <div className='dish-details-modal__allergens-wapper'>
      {dish.allergens.map((all) => {
        const currentLang = getUserLang();
        const allergenName = all.trs?.[currentLang]?.name || all.name;
        const allergenDescription = all.trs?.[currentLang]?.description || all.description;

        return (
          <div className='dish-details-modal__allergens' key={all.id}>
            <SvgIcon type={all.icon.replace('.svg', '')} className='dish-details-modal__allergens-icon' />
            <div className='dish-details-modal__allergens-tooltip'>
              <div className='dish-details-modal__allergens-name'>{allergenName}</div>
              {allergenDescription && (
                <div className='dish-details-modal__allergens-description'>{allergenDescription}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
    {dish.description && (
      <div className='dish-details-modal__description-row'>
        <div className='dish-details-modal__description'>{dish.description}</div>
      </div>
    )}
  </>
);

export default memo(DishHeader);
